export const divideBy100 = (x) => (x / 100).toFixed(2);

